import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule, ModalController } from "ionic-angular";
import { RegLookupControlComponent } from "./reg-lookup-control.component";
import { ResultsModalComponent } from "./results-modal.component";
import { RegLookupControlController } from "./reg-lookup-control.controller";
import { RegLookupControlHelperService } from "./reg-lookup-control-helper.service";
import { ResultsModalController } from "./results-modal.controller";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        RegLookupControlComponent,
        ResultsModalComponent
    ],
    exports: [
        RegLookupControlComponent,
        ResultsModalComponent
    ],
    entryComponents: [
        ResultsModalComponent
    ],
    providers: [
        {
            provide: RegLookupControlHelperService,
            useClass: RegLookupControlHelperService,
            deps: [
                VasAppFacade
            ]
        },
        {
            provide: RegLookupControlController,
            useClass: RegLookupControlController,
            deps: [
                VasAppFacade,
                ModalController,
                RegLookupControlHelperService
            ]
        },
        {
            provide: ResultsModalController,
            useClass: ResultsModalController,
            deps: [
                RegLookupControlHelperService
            ]
        }
    ]
})
export class RegLookupControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/reg-lookup-control.module.ts